import request from '@/utils/request'

// 查询【我公海客户】列表
export function listCust(query) {
  return request({
    url: '/scrm/highseas/list',
    method: 'get',
    params: query
  })
}

// 查询【我公海客户】列表
export function getInfo(custId) {
  return request({
    url: `/scrm/highseas/${custId}`,
    method: 'get'
  })
}

// 查询【我公海客户】详细
export function getCust(custId) {
  return request({
    url: '/scrm/highseas/' + custId,
    method: 'get'
  })
}

// 新增【我公海客户】
export function addCust(data) {
  return request({
    url: '/scrm/highseas',
    method: 'post',
    data: data
  })
}

// 修改【我公海客户】
export function updateCust(data) {
  return request({
    url: '/scrm/highseas',
    method: 'put',
    data: data
  })
}

// 删除【我公海客户】
export function delCust(custId) {
  return request({
    url: '/scrm/highseas/' + custId,
    method: 'delete'
  })
}

// 申领【我公海客户】
export function applyCust(data) {
  return request({
    url: '/scrm/highseas/apply' ,
    method: 'put',
    data: data
  })
}

// 导出【我公海客户】
export function exportCust(query) {
  return request({
    url: '/scrm/highseas/export',
    method: 'get',
    params: query
  })
}

// 下载客户导入模板
export function importTemplate() {
  return request({
    url: '/scrm/highseas/importTemplate',
    method: 'get'
  })
}
